import { FormHelperText, TextField } from "@mui/material";
import { NodeConfig } from "../../types/nodes";
import { WorkflowNode, InputDataRow } from "../../types/workflow";
import RunConfigField from "./RunConfigField";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import InputDataSection from "./InputDataSection";
import { ResponseConfigOption } from "../../types/common";

type TriggerSetupProps = {
    openConditionsDetails: boolean,
    localConditions: any,
    removeCondition: any,
    setLocalConditions: any,
    responseConfig: any,
    isAnyStepIncomplete: boolean,
    setConditionsOpenDetails: (openDetails: boolean) => void,
    addNewCondition: () => void,
    onSave: (action?: string, cb?: () => void, isIntermittentSave?: boolean) => void,
    workflowNode: WorkflowNode,
    nodeRunConfig: Record<string, string | null>,
    setNodeRunConfigAndRefNodeId: (key: string, value: string, refNodeId?: string) => void,
    nodeConfig: NodeConfig,
    saveConfigField: (key: string) => void,
    chosenAction: string,
    resetNodeRunConfigInRef: (run_config: Record<string, string>, run_config_metadata: Record<string, {ref_node_id: string}>) => void,
    inputRows: InputDataRow[],
    setInputRows: (value: SetStateAction<InputDataRow[]>) => void,
    filterText: string,
    nodeId: string,
    countToNameMap: Record<string, string>,
};

const getDisplayValue = (key: string, nodeRunConfig: Record<string, string | null>): string => {
    if (nodeRunConfig && key in nodeRunConfig) {
        return (nodeRunConfig as Record<string, unknown>)?.[key]?.toString().trim() || '';
    }

    return '';
};

const TriggerSetupCodeNode = ({
    nodeRunConfig,
    setNodeRunConfigAndRefNodeId,
    nodeConfig,
    responseConfig,
    chosenAction,
    saveConfigField,
    openConditionsDetails,
    localConditions,
    removeCondition,
    setLocalConditions,
    isAnyStepIncomplete,
    setConditionsOpenDetails,
    addNewCondition,
    onSave,
    workflowNode,
    resetNodeRunConfigInRef,
    inputRows,
    setInputRows,
    filterText,
    nodeId,
    countToNameMap,
}: TriggerSetupProps) => {
    const keysToRender = new Set([
        ...(nodeRunConfig && Object.keys(nodeRunConfig)?.length ? Object.keys(nodeRunConfig) : [])
    ]);
    const { run_config_metadata, run_config_render_data } = nodeConfig || {};
    const [inputParams, setInputParams] = useState([]);
    const shouldRender = (nodeRunConfig && !!Object.keys(nodeRunConfig)?.length);

    const dropdownOptionIdToOptionMap = useMemo(() => {
        let dropdownOptionIdToOptionMap: Record<string, ResponseConfigOption> = {};
        if (responseConfig?.length) {
            responseConfig.forEach((option: ResponseConfigOption) => {
                dropdownOptionIdToOptionMap[`${option.id}:${option.refNodeId}`] = {
                    ...option,
                    value: typeof option.value !== "object" ? option.value : ""
                }
            });
        }

        return dropdownOptionIdToOptionMap;
    }, [responseConfig]);
    
    if (!shouldRender) return <FormHelperText>No details for this action</FormHelperText>;

    return (
        <>
            {/* Other fields */}
            <div className="font-sm text-sm mb-2">Input Data Mapping</div>
            <InputDataSection
                nodeRunConfig={nodeRunConfig}
                nodeRunConfigMetadata={run_config_metadata}
                responseConfig={responseConfig}
                inputRows={inputRows}
                setInputRows={setInputRows}
                dropdownOptionIdToOptionMap={dropdownOptionIdToOptionMap}
                onSave={onSave}
                nodeId={nodeId}
                countToNameMap={countToNameMap}
            />
            {/* Code field */}
            <TextField fullWidth multiline
                defaultValue={getDisplayValue('code', nodeRunConfig)}
                onChange={(e) => {
                    setNodeRunConfigAndRefNodeId('code', e.target.value);
                }}
                // onBlur={() => saveConfigField('code')}
                onBlur={() => onSave("", () => {}, true)}
                placeholder="Code"
                rows={6}
                maxRows={20}
                size="small"
                sx={{
                    '& .MuiInputBase-root': {
                        fontFamily: 'monospace',  // Better for code
                    }
                }}
            />  
        </>
    );
}

export default TriggerSetupCodeNode;
